import React, { Fragment, useEffect, useState } from "react";
import cx from "classnames";

import { connect } from "react-redux";
import { Button } from "reactstrap";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import HeaderLogo from "../AppLogo";
import { useLoginStatus, useUserEmail } from "../AppMain/LoginStatusContext";

import SearchBox from "./Components/SearchBox";
import UserBox from "./Components/UserBox";
import * as Ionicons from "react-icons/io";
import SupporterSignUp from "../../Pages/SupporterSignUp";
import CSOSignUp from "../../CSOSignUp/CSOSignUp";
import { Link } from "react-router-dom";

import "./appHeader.css";
import { useQuery } from "@apollo/client";
import { CHECK_USER_STATUS } from "../../queries";
import ConfirmationModal from "../../Pages/SupporterSignUp/ConfirmationModal";

import { useLocation } from "react-router-dom";
import CSORegisterModal from "../../components/CSORegister/Modal";
import WarningModal from "../../Pages/SupporterSignUp/WarningModal";

const Header = ({
  setSearchContexts,
  context,
  search,
  queryParams,
  setQueryParams,
}) => {
  const loginStatus = useLoginStatus();
  const location = useLocation();

  let params = new URLSearchParams(location?.search);

  let headerBackgroundColor = "";
  let enableMobileMenuSmall = "";
  let enableHeaderShadow = "";

  const triggerAlert = () => {
    alert("資料ダウンロードには、ログインが必要です。");
  };

  const [freezeModal, setFreezeModal] = useState(false);
  const [openSupporterAcc, setOpenSupporterAcc] = useState(false);
  const [modalCsoSignup, setModalCsoSignup] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] =
    useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [csoRegisterModalOpen, setCsoRegisterModalOpen] = useState(false);

  const userStatus = useQuery(CHECK_USER_STATUS, {
    variables: { email: useUserEmail() },
  });

  const toggleSupporterAcc = () => {
    if (freezeModal) {
      return;
    }
    setOpenSupporterAcc(!openSupporterAcc);
  };

  const toggleCsoRegisterModal = () => {
    if (freezeModal) {
      return;
    }
    setCsoRegisterModalOpen(!csoRegisterModalOpen);
  };

  const toggleConfirmationModalVisible = () => {
    setConfirmationModalVisible(!confirmationModalVisible);
  };

  useEffect(() => {
    const isShowModal = Boolean(params.get("modal"));
    if (isShowModal) {
      setModalCsoSignup(true);
    }
  }, [location]);

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        className={cx("app-header", headerBackgroundColor, {
          "header-shadow": enableHeaderShadow,
        })}
        transitionName="HeaderAnimation"
        transitionAppear={true}
        transitionAppearTimeout={1500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <HeaderLogo />
        <div
          className={cx("app-header__content", {
            "header-mobile-open": enableMobileMenuSmall,
          })}
        >
          <div className="app-header-left">
            <SearchBox
              context={context}
              setSearchContext={setSearchContexts}
              search={search}
              params={params}
              setQueryParams={setQueryParams}
              queryParams={queryParams}
            />
          </div>
          <div className="app-header-right">
            {!loginStatus && (
              <Button
                className="mb-2 mr-2 mt-2 hide-sp"
                color="info"
                onClick={() => {
                  setModalCsoSignup(true);
                }}
              >
                アカウント登録
              </Button>
            )}

            {/* <Button
              className="mb-2 mr-2 mt-2 hide-sp"
              color="info"
              onClick={() => {
                // toggleSupporterAcc();
                toggleConfirmationModalVisible();
              }}
            >
              組織としてアカウント利用
            </Button> */}

            {loginStatus ? (
              userStatus?.data?.allUsers?.edges[0]?.node?.isSupporter ||
              userStatus?.data?.allUsers?.edges[0]?.node?.isCso ? (
                <></>
              ) : (
                <Button
                  className="mb-2 mr-2 mt-2 hide-sp"
                  color="info"
                  onClick={() => {
                    // toggleSupporterAcc();
                    toggleConfirmationModalVisible();
                  }}
                >
                  組織としてアカウント利用
                </Button>
              )
            ) : (
              <Button
                className="mb-2 mr-2 mt-2 hide-sp"
                color="info"
                onClick={() => {
                  // toggleSupporterAcc();
                  toggleConfirmationModalVisible();
                }}
              >
                組織としてアカウント利用
              </Button>
            )}

            <a href="/#/dashboards/faq">
              {/* <a href={loginStatus ? "/#/dashboards/faq" : "/#/pages/login"}> */}
              <Button className="fav_btn_pc fav_btn_off">FAQ</Button>
            </a>

            <a href="/#/dashboards/faq">
              <i
                className="pe-7s-help1 mr-2 header_hatena_sp"
                style={{ fontSize: 44, color: "#8d8d8d" }}
              />
            </a>
            <UserBox onRegisterClick={() => setModalCsoSignup(true)} />
          </div>
        </div>
      </CSSTransitionGroup>
      <ConfirmationModal
        open={confirmationModalVisible}
        setOpen={toggleConfirmationModalVisible}
        onConfirm={() => {
          toggleConfirmationModalVisible();
          if (!loginStatus) {
            setModalCsoSignup(true);
          } else {
            toggleSupporterAcc();
          }
        }}
        onRegisterCso={() => {
          toggleConfirmationModalVisible();
          if (!loginStatus) {
            setModalCsoSignup(true);
          } else {
            // toggleCsoRegisterModal();
            setWarningModalVisible(true);
          }
        }}
      />
      <WarningModal
        open={warningModalVisible}
        setOpen={() => {
          setWarningModalVisible(!warningModalVisible);
        }}
        onConfirm={() => {
          setWarningModalVisible(false);
          setCsoRegisterModalOpen(true);
        }}
      />
      <SupporterSignUp
        open={openSupporterAcc}
        setOpen={toggleSupporterAcc}
        setFreezeModal={setFreezeModal}
        freezeModal={freezeModal}
      />
      <CSOSignUp
        isOpen={modalCsoSignup}
        onClose={() => setModalCsoSignup(false)}
      />
      <CSORegisterModal
        open={csoRegisterModalOpen}
        setOpen={toggleCsoRegisterModal}
        setFreezeModal={setFreezeModal}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
